import styled from 'styled-components';
import { StyledLink } from '../../../css/styledComponents.styles';

export const SecondaryNavContainer = styled.div`
  height: 54px;
  display: flex;
  align-items: center;
`;

export const LinkButton = styled(StyledLink)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 4px;
  }
`;
